import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const DebtHistoryBreadcrumb = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #6B7280;
	padding: 16px 0px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
	color: ${props => props.active ? '#9CA3AF' : '#374151'};
	cursor: ${props => props.active ? 'default' : 'pointer'};
	text-decoration: none;
	
	&:hover {
		color: ${props => props.active ? '#9CA3AF' : '#1F2937'};
	}
`;

export const BreadcrumbSeparator = styled.img`
	width: 12px;
	height: 12px;
	margin: 0 4px;
`;

export const DebtHistoryContainer = styled.div`
	width: 1200px;
	position: relative;
	margin: 0 auto;
	max-width: 1440px;
	padding: 24px 0 40px;
	font-size: 16px;
	background-color: #F3F4F6;
	
	@media screen and (max-width: 768px) {
		margin: 0;
		width: 100%;
		padding: 0 16px 16px 16px;
	}
`;

export const DebtHistoryCard = styled.div`
	background: white;
	border-radius: 12px;
	padding: 17px 19px;
	margin-bottom: 24px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const DebtHistoryTitle = styled.h2`
	font-size: 18px;
	font-weight: 600;
	color: #111827;
	margin: 0 0 10px 0;
`;

export const DebtHistorySearchForm = styled.div`
	display: flex;
	gap: 12px;
	align-items: flex-end;
	flex-wrap: wrap;
	
	@media screen and (max-width: 768px) {
		flex-direction: column;
		align-items: stretch;
	}
`;

export const DebtHistorySearchInputWrapper = styled.div`
	flex: 1;
	min-width: 200px;
	position: relative;

`;

export const DebtHistorySearchInput = styled.input`
	width: 100%;
	padding: 10px 12px 10px 40px;
	border-radius: 8px;
	font-size: 14px;
	border: 1px solid #E5E7EB;
	background-color: #F9FAFB;
	
	&:focus {
		outline: none;
	}

	&::placeholder {
		color: #111827;
	}
`;

export const DebtHistorySearchIcon = styled.img`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	width: 16px;
	height: 16px;
	pointer-events: none;
`;

export const DebtHistorySelect = styled.select`
	padding: 10px 30px 10px 12px;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	background-color: white;
	cursor: pointer;
	color: #111827;
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 8px center;
	min-width: 180px;
	
	&:focus {
		outline: none;
		border-color: #3B82F6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`;

export const DebtHistoryPeriodSelectWrapper = styled.div`
	position: relative;
	min-width: 200px;
`;

export const DebtHistoryPeriodSelect = styled.select<{ calendarIcon?: string }>`
	padding: 10px 50px 10px 12px;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	background-color: white;
	cursor: pointer;
	color: #111827;
	appearance: none;
	background-image: ${props => props.calendarIcon ? `url(${props.calendarIcon})` : 'none'}, url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat, no-repeat;
	background-position: right 30px center, right 8px center;
	background-size: 16px 16px, 12px 12px;
	width: 100%;
	
	&:focus {
		outline: none;
		border-color: #3B82F6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`;

export const DebtHistorySearchButton = styled.button`
	padding: 10px 24px;
	background-color: #005E9E;
	color: white;
	border: none;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	white-space: nowrap;
	width: 200px;
	
	&:hover {
		background-color: #005E9E;
	}
	
	&:disabled {
		background-color: #9CA3AF;
		cursor: not-allowed;
	}
`;

export const DebtHistoryHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
	flex-wrap: wrap;
	gap: 16px;
`;

export const DebtHistoryPartnerName = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: #111827;
	margin: 0;
`;

export const DebtHistoryHeaderActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
`;

export const DebtHistoryStatusFilter = styled.select`
	padding: 8px 30px 8px 12px;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	background-color: white;
	cursor: pointer;
	color: #111827;
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 8px center;
	min-width: 150px;
	
	&:focus {
		outline: none;
		border-color: #3B82F6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`;

export const DebtHistoryExportButton = styled.button`
	padding: 8px 16px;
	background-color: white;
	color: #005E9E;
	border: 1px solid #D1D5DB;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
	
	&:hover {
		background-color: #F3F4F6;
	}
`;

export const DebtHistoryTable = styled.div`
	background: white;
	border-radius: 12px;
	overflow: auto;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const DebtHistoryTableHeader = styled.div`
	display: grid;
	grid-template-columns: 170px 130px 100px 130px 130px 120px 170px 220px 170px 130px;
	gap: 16px;
	padding: 16px 24px;
	background-color: #F9FAFB;
	border-bottom: 1px solid #E5E7EB;
	font-size: 12px;
	font-weight: 600;
	color: #6B7280;
	text-transform: uppercase;
	
	@media screen and (max-width: 1200px) {
		grid-template-columns: 170px 130px 100px 130px 130px 120px 170px 220px 170px 130px;
		font-size: 11px;
		gap: 12px;
		padding: 12px 16px;
	}
`;

export const DebtHistoryTableRow = styled.div<{ backgroundColor?: string }>`
	display: grid;
	grid-template-columns: 170px 130px 100px 130px 130px 120px 170px 220px 170px 130px;
	gap: 16px;
	padding: 16px 24px;
	background-color: ${props => props.backgroundColor || '#FFFFFF'};
	border-bottom: 1px solid #E5E7EB;
	transition: background-color 0.2s;
	
	&:hover {
		background-color: #F9FAFB;
	}
	
	&:last-child {
		border-bottom: none;
	}
	
	@media screen and (max-width: 1200px) {
		grid-template-columns: 170px 130px 100px 130px 130px 120px 170px 220px 170px 130px;
		gap: 12px;
		padding: 12px 16px;
	}
`;

export const DebtHistoryTableCell = styled.div<{ alignRight?: boolean }>`
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #111827;
	word-break: break-word;
	justify-content: ${props => props.alignRight ? 'flex-end' : 'flex-start'};
`;

export const DebtHistoryStatusBadge = styled.span<{ backgroundColor: string; textColor: string }>`
	display: inline-flex;
	align-items: center;
	padding: 4px 12px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
	background-color: ${props => props.backgroundColor};
	color: ${props => props.textColor};
	border: 1px solid ${props => props.textColor};
	gap: 6px;
`;

export const DebtHistoryStatusDot = styled.span<{ color: string }>`
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: ${props => props.color};
	flex-shrink: 0;
`;

export const DebtHistoryActionLink = styled(Link)`
	color: #005E9E;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 4px;
	
	&:hover {
		color: #1D4ED8;
		text-decoration: underline;
	}
`;

export const DebtHistoryActionLinkRed = styled(Link)`
	color: #F04438;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 4px;
	text-decoration: none;
	
	&:hover {
		color: #F04438;
	}
`;

export const DebtHistoryActionButton = styled.button`
	color: #ffffff;
	background: #0B74C6;
	border: none;
	border-radius: 8px;
	padding: 7px 12px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: #095F9F;
	}
`;

export const DebtHistoryEmptyState = styled.div`
	text-align: center;
	padding: 60px 20px;
	color: #6B7280;
`;
